/**
 * Google AdSense loader — no-ops until REACT_APP_ADSENSE_CLIENT_ID is set.
 * Enables Auto ads via the head script; use <AdSenseUnit> for manual placements.
 *
 * Set in production env (GitHub Secret / hosting):
 *   REACT_APP_ADSENSE_CLIENT_ID=ca-pub-XXXXXXXXXXXXXXXX
 *   REACT_APP_ADSENSE_SLOT_HOME=1234567890        (optional display unit)
 *   REACT_APP_ADSENSE_SLOT_ARTICLE=1234567890     (optional)
 *   REACT_APP_ADSENSE_SLOT_JOURNEY=1234567890     (optional)
 */
export const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT_ID;

export const AD_SLOTS = {
	home: process.env.REACT_APP_ADSENSE_SLOT_HOME,
	article: process.env.REACT_APP_ADSENSE_SLOT_ARTICLE,
	journey: process.env.REACT_APP_ADSENSE_SLOT_JOURNEY,
};

const BLOCKED_PREFIXES = [
	'/login',
	'/signup',
	'/reset-password',
	'/admin',
	'/partner',
	'/partners',
	'/booking',
	'/payment_success',
	'/inquiry',
	'/confirm',
	'/verify',
	'/vendor/onboarding',
	'/vendor-signup',
	'/ticket',
	'/group-trips',
	'/packages',
	'/shared-rentals',
	'/book-experiences',
	'/rentals',
];

let initialized = false;

export function isAdSenseEnabled() {
	return !!ADSENSE_CLIENT;
}

export function shouldShowAds(pathname = '') {
	if (!isAdSenseEnabled()) return false;
	return !BLOCKED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

/** Load AdSense script once on editorial routes — enables Auto ads when approved */
export function initAdSense(pathname = '') {
	if (!ADSENSE_CLIENT || initialized) return;
	const path = pathname || (typeof window !== 'undefined' ? window.location.pathname : '');
	if (!shouldShowAds(path)) return;
	initialized = true;

	const script = document.createElement('script');
	script.async = true;
	script.crossOrigin = 'anonymous';
	script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
	document.head.appendChild(script);
}

/** Request fill for a manual <ins class="adsbygoogle"> unit */
export function pushAdUnit() {
	if (!isAdSenseEnabled()) return;
	try {
		(window.adsbygoogle = window.adsbygoogle || []).push({});
	} catch (err) {
		// Ad blockers or script not ready — fail silently
		if (process.env.NODE_ENV === 'development') {
			console.warn('AdSense: push failed', err);
		}
	}
}
